jQuery(function () {
    var maintenanceActionId;
    var maintenanceAction = $('.maintenance-action-id');
    if (maintenanceAction.length > 0) {
        maintenanceActionId = maintenanceAction.data('id');
    }
    $('.js-status-bar-toggle-btn').on('click', function () {
        var toggleBtn = $(this);
        var statusBar = toggleBtn.next('.status-bar');
        statusBar.slideToggle();
        toggleBtn.toggleClass('expanded');
    });
    $('.js-maintenance-action-notification-toggle-btn').on('click', function () {
        $(this).find('.toggle-switch').toggleClass('active');
        var remindMe = $(this).find('.toggle-switch').hasClass('active');
        $.ajax({
            type: 'POST',
            url: '/atgard/paminn-mig',
            data: { actionId: maintenanceActionId, remindMe: remindMe },
            success: function () {
                //remove empty success?
            }
        });
    });
    var postChangedDate = function () {
        var year = $('.js-maintenance-action-year-select').val();
        var month = $('.js-maintenance-action-month-select').val();
        $.ajax({
            type: 'POST',
            url: '/atgard/uppdatera-datum',
            data: { actionId: maintenanceActionId, year: year, month: month },
            success: function () {
                //Remove empty success?
            }
        });
    };
    $('.js-maintenance-action-month-select').on('change', function () {
        postChangedDate();
    });
    $('.js-maintenance-action-year-select').on('change', function () {
        postChangedDate();
    });
    $('.js-maintenance-action-show-remove-popup-btn').on('click', function () {
        $('#maintenance-action-remove-popup').closest('.popup-overlay').addClass('visible');
    });
    $('.js-maintenance-action-remove-btn').on('click', function () {
        $.ajax({
            type: 'POST',
            url: '/atgard/ta-bort',
            data: { actionId: maintenanceActionId },
            success: function () {
                document.location.href = '/underhallsplan/atgarder';
            }
        });
    });
});
